export class PageBlockSlides {

    public blockTitle = null;
    public faq = null;
    public id = null;
    public imageUrl = null;
    public removeFromNav = null;
    public text = null;
    public type = null;
    
    public slides = null;

    constructor(pageBlockSlides) {
        this.blockTitle = pageBlockSlides.blockTitle;
        this.faq = pageBlockSlides.faq;
        this.id = pageBlockSlides.id;
        this.imageUrl = pageBlockSlides.imageUrl;
        this.removeFromNav = pageBlockSlides.removeFromNav;
        this.text = pageBlockSlides.text;
        this.type = pageBlockSlides.type;

        this.slides = pageBlockSlides.slides.map(slide => {
            return new SlideElement(slide);
        });
    }

    getMenuElement(url, index) {
        return {
            href: url + '#slides-' + index,
            name: this.blockTitle.replace(/<[^>]*>/g, '')
        }
    }
}

export class SlideElement {
    public imageUrl = null;
    public name = null;
    public sequence = null;
    public title = null;

    constructor(slideElement) {
        this.imageUrl = slideElement.imageUrl || '/images/org_logo_default_v2.svg';
        this.name = slideElement.name;
        this.sequence = slideElement.sequence;
        this.title = slideElement.title;
    }
}